'use strict';
import React, {Component, Fragment} from 'react';
import ReactDOM from 'react-dom';
import onClickOutside from "react-onclickoutside";
import MaskedInput from 'react-text-mask';

export default class InputKeyboard extends Component{

  state = {
    showIcon: false,
    showKeyboard: false,
    left: 0,
    top: 0,
  }

  inputRef = React.createRef();
  input = React.createRef();

  handleFocus = () => {
    this.setState({showIcon: true});
  }

  handleCloseKeyboard = () => {
    this.setState({
      showIcon: this.props.forceShowIcon || false,
      showKeyboard: false
    });
  }

  componentDidUpdate(){
    // console.log('updateKeyboard');
    // this.setPosition();
  }

  componentDidMount() {
    if (this.props.forceShowIcon) {
      this.handleFocus();
    }
  };

  setPosition = () => {
    let node;
    if (this.props.mode == 'mask') {
      node = this.input.current.inputElement.getBoundingClientRect();
    } else {
      node = this.input.current.getBoundingClientRect();
    }

    let positionX = this.props.positionX ? this.props.positionX : 'left';
    let positionY = this.props.positionY ? this.props.positionY : 'bottom';
    let top, left;

    if (positionX == 'left') {
      left = node.left - 5 - 196;
    } else if (positionX == 'right') {
      left = node.left + 5 + node.width;
    }

    if (positionY == 'top') {
      top = node.top + window.pageYOffset;
    } else if (positionY == 'bottom') {
      top = node.top + window.pageYOffset;
    }

    this.setState({
      // showIcon: true,
      top: top,
      left: left
    });
  }

  handleFocus = () => {

    this.setPosition();

    this.setState({
      showIcon: true,
    });
  }

  render() {

    const { value, positionX, positionY, onChange, mode, mask, ...other } = this.props;

    let input = null;
    if (mode == 'mask') {
      input = <MaskedInput {...other} mask={mask} guide={false} ref={this.input} value={value} onFocus={this.handleFocus} onChange={(e) => onChange(e.target.value)}/>;
    } else {
      input = <input {...other} ref={this.input} value={value} onFocus={this.handleFocus} onChange={(e) => onChange(e.target.value)}/>;
    }

    return(
      <span className="ui-keyboard-container" ref={this.inputRef}>
        { this.state.showIcon ?
          <KeyboardContainer>
            <div className={`ui-keyboard-icon-wrapper ${positionX}`} onClick={this.handleShowKeyboard} style={{top: this.state.top, left: this.state.left}}>
              <VirtualKeyboard
                positionY={positionY}
                positionX={positionX}
                onChange={onChange}
                onClose={this.handleCloseKeyboard}
                value={value}
                inputRef={mode == 'mask' ? this.input.current.inputElement : this.input.current}
                caretPos={this.input.current.selectionStart}
                showKeyboard={this.state.showKeyboard}
                onShowKeyboard={(value = true) => this.setState({showKeyboard: value})}
              />
            </div>
          </KeyboardContainer>
        : ''}
        {input}
        {/*<input {...other} ref={this.input} value={value} onFocus={this.handleFocus} onChange={(e) => onChange(e.target.value)}/>*/}
      </span>
    )
  }
}

class KeyboardContainer extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.modal = document.getElementById('keyboard');
  }

  componentDidMount() {
    this.modal.appendChild(this.el);
  }

  componentWillUnmount() {
    this.modal.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}

@onClickOutside
class VirtualKeyboard extends Component {

  componentDidMount() {
    window.addEventListener("blur", () => {this.props.onClose()});
  }

  componentWillUnmount() {
    window.removeEventListener("blur", () => {this.props.onClose()});
  }

  customLayout = {
    'default' : [ [1, 2, 3], [4, 5, 6], [7, 8, 9], ['.', 0, 'b']]
  };

  handleKeyboard = (val) => {
    let str = String(this.props.value);
    // this.props.inputRef.focus();
    let caret = this.props.inputRef.selectionStart;
    let split = ['',''];
    if (val == 'b') {
      split[0] = str.substring(0, caret);
      split[1] = str.substring(caret, str.length);
      str = split[0].substring(0, split[0].length - 1);
      str = str + split[1];
      --caret;
    } else {
      const maxlength = parseInt(this.props.inputRef.getAttribute('maxlength'));

      if (maxlength && str.length + 1 > maxlength) {
          return false;
      }
      split[0] = str.substring(0, caret);
      split[1] = str.substring(caret, str.length);
      // t.data.input.value = split[0] + val + split[1];
      ++caret;
      str = split[0] + val + split[1];
    }
    this.props.onChange(str);
    this.props.inputRef.focus();
    setTimeout(() => {
      this.props.inputRef.setSelectionRange(caret, caret);
    }, 10);
  }

  handleClickOutside(evt) {
    this.props.onShowKeyboard(false)
    if(evt.path && evt.path[0] != this.props.inputRef){
      this.props.onClose();
    };
  }

  handleClickIcon = () => {
    this.props.onShowKeyboard();
    this.props.inputRef.focus();
  }

  render() {
    const layout = this.props.type ? this.props.type : 'default';
    const {showKeyboard, positionX, positionY} = this.props;
    const style = positionY == 'top' ? {top : '-156px'} : {};

    return (
      <div>
        <div className={`ui-keyboard-wrapper${!showKeyboard ? ' hidden' : ''}`} style={style}>
          <div className="ui-keyboard">
            <div className="ui-keyboard-keyset">
              { this.customLayout[layout].map( el => 
                <Fragment key={el[0]}>
                  <Buttons items={el} handleClick={this.handleKeyboard}/>
                  <br className="ui-keyboard-button-endrow" />
                </Fragment>
              )}
            </div>
          </div>
        </div>
        <span className={`ui-keyboard-icon-container ${positionX}${showKeyboard ? ' hidden' : ''}`} onClick={this.handleClickIcon}>
          <span className="ui-keyboard-icon"></span>
        </span>
      </div>
    )
  }
}

const Buttons = ({items, handleClick}) => {
  let buttons = items.map( el => {
    if (el == 'b') {
      return <div onClick={() => handleClick(el)} key={el} tabIndex="-1" className="ui-keyboard-button ui-keyboard-bksp" title="Backspace"><span className="ui-keyboard-text">⌫</span></div>
    } else if (el == 'a') {
      return <div onClick={() => handleClick(el)} key={el}  tabIndex="-1" className="ui-keyboard-button ui-keyboard-accept"><span className="ui-keyboard-text">✔</span></div>
    } else {
      return <div onClick={() => handleClick(el)} key={el}  tabIndex="-1" className="ui-keyboard-button"><span className="ui-keyboard-text">{el}</span></div>
    }
  })

  return buttons;
}


// WEBPACK FOOTER //
// ./src/components/keyboard/keyboardInput.jsx